import React, { FC, memo, ReactNode } from "react"
import { Spin as AntdSpin } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import css from "./Spin.module.css"
import { SpinSize } from "antd/lib/spin"

const icon = <LoadingOutlined className={css.icon} spin />

type SpinProps = {
    children?: ReactNode
    size?: SpinSize
}

const Spin: FC<SpinProps> = ({ children, size }) => {
    return (
        <AntdSpin className={css.root} indicator={icon} delay={100} size={size}>
            {children}
        </AntdSpin>
    )
}

export default memo(Spin)
